import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import "./assets/styles/app.min.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/effect.css";
//import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import { ToastContainer } from 'react-toastify';
import './config/i18n';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
        <App />
        <ToastContainer className={"z-[999999]"} />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
